import { render, staticRenderFns } from "./TheTagsBox.vue?vue&type=template&id=3f046eb2&scoped=true"
import script from "./TheTagsBox.vue?vue&type=script&lang=js"
export * from "./TheTagsBox.vue?vue&type=script&lang=js"
import style0 from "./TheTagsBox.vue?vue&type=style&index=0&id=3f046eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f046eb2",
  null
  
)

export default component.exports